import { useQuery } from '@tanstack/react-query'
import { api } from '.'

/** Query keys, so a cache entry is named once and invalidated by the same name. */
export const queryKeys = {
  plan: ['plan'] as const,
}

/** `GET /plan`, shared by the home screen and the drill screen. */
export function usePlan() {
  return useQuery({ queryKey: queryKeys.plan, queryFn: () => api.getPlan() })
}
